import React, { useMemo } from 'react';
import EditableTable from '../../reUsableTemplates/EditableTable/EditableTable';
import { columnsToTableHeader } from './reportRegistry';

/**
 * Read-only report table (Input Matrix styling, download only).
 */
function ReportEditableTable({
    config,
    data,
    date,
    setLoading,
    showSnackbar,
    monthfilterreport,
    title,
    headerColumns,
}) {
    const header = useMemo(() => {
        const cols =
            headerColumns?.length > 0
                ? headerColumns
                : config.columns;
        return columnsToTableHeader(cols);
    }, [headerColumns, config.columns]);

    const displayTitle = title ?? config.title;
    const rows = Array.isArray(data) ? data : [];

    return (
        <EditableTable
            header={header}
            mainIcon={config.icon}
            mainIconColor={config.iconColor}
            title={displayTitle}
            data={rows}
            date={date}
            setLoading={setLoading}
            showSnackbar={showSnackbar}
            hideColumnHeaderIcons
            viewOnly
            getEditPermission={false}
            getDeletePermission={false}
            actionChecked=""
            setActionChecked={() => {}}
            monthfilterreport={monthfilterreport}
            createOrfilterComp={<></>}
            setEditableRow={() => {}}
            setEditedValues={() => {}}
            editedValues={{}}
            editableRow={null}
            handledeleteClickOpenalert={() => {}}
            handleSaveClick={() => {}}
            submitdelete={() => {}}
        />
    );
}

export default ReportEditableTable;
